import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Request, Headers, ResponseContentType, ResponseOptions } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';
import 'rxjs/add/Observable/throw';
import 'rxjs/add/operator/toPromise';
import { global } from '../../models/global';
import { UpdateNotification } from 'src/app/Models/login/profile';
import { DropDownResponse } from 'src/app/Models/Dashboard/DashboardFilters';

@Injectable({
    providedIn : 'root'
})
export class WHStockInService {

    ROOT_URL : string = "";
    constructor(private http : Http) {
        let g : global = new global();
        this.ROOT_URL = g.getApiUrl();
    }

    getFilters() : Observable<any> {
        let userID = localStorage.getItem('mcmt_userId');
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization':'Bearer '+ localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId')  });
        let requestoptions : RequestOptions = new RequestOptions({
            method : 'GET',
            //url : this.ROOT_URL + "/api/Invetory/WarehouseStockInFilters?userID="+userID,
            url : this.ROOT_URL + "/api/Inventory/WarehouseStockInFilter?userID="+userID,
            headers : headers
        })
        
        return this.http.request(new Request(requestoptions))
            .map((res : Response) => {
                return res.json();
            });

    }
    changeRequest(type:number) : Observable<any> {
        let _body = {
            "UserID" : localStorage.getItem('mcmt_userId'),
            "Type":type
            }
            
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization':'Bearer '+ localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId')  });
        let requestoptions : RequestOptions = new RequestOptions({
            method : 'POST',
            //url : this.ROOT_URL + "/api/Dashboard/DashboardDetails",
            url : this.ROOT_URL + "/api/Inventory/WarehouseChangeRequest",
            headers : headers,
            body : _body
        })
        
        return this.http.request(new Request(requestoptions))
            .map((res : Response) => {
                return res.json();
            });

    }

    getProductionSavedDetails(jobNumber : any, name : any, type : any, brand : any, crop : any, requirementType : any,
        language : any, status : any, po:any) : Observable<any> {
        let _body = {
            "UserID" : localStorage.getItem('mcmt_userId'),
            "JobNumber" : jobNumber,
            "RMHName" : name,
            "JobType" : type,
            "Brand" : brand,
            "Crop" : crop,
            "RequirementType" : requirementType,
            "Language" : language,
            "OrderStatus" : status,
            "PO":po
            }
            
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization':'Bearer '+ localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId')  });
        let requestoptions : RequestOptions = new RequestOptions({
            method : 'POST',
            url : this.ROOT_URL + "/api/Production/WarehouseStockInDetails",
            headers : headers,
            body : _body
        })
        
        return this.http.request(new Request(requestoptions))
            .map((res : Response) => {
                return res.json();
            });

    }

    getWarehouseStockInDetails(jobNumber : any, name : any, type : any, brand : any, crop : any, requirementType : any,
        language : any, status : any, po:any, year: any) : Observable<any> {
        let _body = {
            "UserID" : localStorage.getItem('mcmt_userId'),
            "JobNumber" : jobNumber,
            "RMHName" : name,
            "JobType" : type,
            "Brand" : brand,
            "Crop" : crop,
            "RequirementType" : requirementType,
            "Language" : language,
            "OrderStatus" : status,
            "PO":po,
            "Year": year
            }
            
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization':'Bearer '+ localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId')  });
        let requestoptions : RequestOptions = new RequestOptions({
            method : 'POST',
            url : this.ROOT_URL + "/api/Inventory/WarehouseStockInDetails",
            headers : headers,
            body : _body
        })
        
        return this.http.request(new Request(requestoptions))
            .map((res : Response) => {
                return res.json();
            });

    }
    getSaveSubmitStatus() : Observable<any> {
        let _body = {
            "UserID" : localStorage.getItem('mcmt_userId')
            }
            
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization':'Bearer '+ localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId')  });
        let requestoptions : RequestOptions = new RequestOptions({
            method : 'POST',
            url : this.ROOT_URL + "/api/Inventory/GetSaveSubmitStatus",
            headers : headers,
            body : _body
        })
        
        return this.http.request(new Request(requestoptions))
            .map((res : Response) => {
                return res.json();
            });

    }
    saveAsDraftStockInDetails(JobNumber:any,StockInQuantity:any,PONumber:any,StockInDate:any,WHRemarks,Type:number) : Observable<any> {
        let _body = {
            "UserID" : localStorage.getItem('mcmt_userId'),
            "JobNumber":JobNumber,
            "StockInDate" : StockInDate,
            "StockInQuantity" : StockInQuantity,
            "PONumber":PONumber,
            "WHRemarks":WHRemarks,
            "Type":Type
            }
            
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization':'Bearer '+ localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId')  });
        let requestoptions : RequestOptions = new RequestOptions({
            method : 'POST',
            //url : this.ROOT_URL + "/api/Dashboard/DashboardDetails",
            url : this.ROOT_URL + "/api/Inventory/SaveAsDraftStockInDetails",
            headers : headers,
            body : _body
        })
        
        return this.http.request(new Request(requestoptions))
            .map((res : Response) => {
                return res.json();
            });

    }
    

    SubmitProductionDetails(JobNumber:any,poNumber:any,CNNNumber:any,VendorName:any,
        NumberofBoxes:any,Logistics:any,DocketNumber:any,InvoiceNumber:any,InvoiceDate:any,EstimatedDeliveryDate:any,DispatchedDate:any,InvoiceValue:any,
        PaymentDate:any,PoQuantity:any,Remarks:any,Type:number) : Observable<any> {
        let _body = {
            "UserID" : localStorage.getItem('mcmt_userId'),
            "JobNumber":JobNumber,
            "poNumber":poNumber,
            "CNNNumber" : CNNNumber,
            "VendorName":VendorName,
            "NumberofBoxes" : NumberofBoxes,
            "Logistics" : Logistics,
            "DocketNumber" : DocketNumber,
            "InvoiceNumber" : InvoiceNumber,
            "InvoiceDate" : InvoiceDate,
            "EstimatedDate":EstimatedDeliveryDate,
            "DispatchedDate":DispatchedDate,
            "InvoiceValue":InvoiceValue,
            "PaymentDate":PaymentDate,
            "PoQuantity":PoQuantity,
            "Remarks":Remarks,
            "Type":Type
            
            }
            
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization':'Bearer '+ localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId')  });
        let requestoptions : RequestOptions = new RequestOptions({
            method : 'POST',
            //url : this.ROOT_URL + "/api/Dashboard/DashboardDetails",
            url : this.ROOT_URL + "/api/Production/SaveAsDraftproductionDetails",
            headers : headers,
            body : _body
        })
        
        return this.http.request(new Request(requestoptions))
            .map((res : Response) => {
                return res.json();

            });

    }

    getdataonjobnumberselection(jobNumber : any,rmh:any,brand:any,po:any) : Observable<any> {
        let _body = {
            "UserID" : localStorage.getItem('mcmt_userId'),
            "JobNumber" : jobNumber,
            "RMHName":rmh,
            "Brand":brand,
            "PO":po
            }
            
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization':'Bearer '+ localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId')  });
        let requestoptions : RequestOptions = new RequestOptions({
            method : 'POST',
            url : this.ROOT_URL + "/api/Inventory/GetRMHJobnumber",
            headers : headers,
            body : _body
        })
        
        return this.http.request(new Request(requestoptions))
            .map((res : Response) => {
                return res.json();
            });

    }

    DownloadExcel(jobNumber : any, name : any, type : any, brand : any, crop : any, requirementType : any,
        language : any, status : any,po:any, year: any) : Observable<any> {
        let _body = {
            "UserID" : localStorage.getItem('mcmt_userId'),
            "JobNumber" : jobNumber,
            "RMHName" : name,
            "JobType" : type,
            "Brand" : brand,
            "Crop" : crop,
            "RequirementType" : requirementType,
            "Language" : language,
            "OrderStatus" : status,
            "PO":po,
            "Year": year
            }
            let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization':'Bearer '+ localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId')  });
        let requestoptions : RequestOptions = new RequestOptions({
            method : 'POST',
           // url : this.ROOT_URL + "/api/Invetory/DownloadWarehouseStockInExcel",
           url : this.ROOT_URL + "/api/Inventory/DownloadExcelWHStockInExcel",
            headers : headers,
            body : _body,
            responseType : ResponseContentType.Blob
        })
        
        return this.http.request(new Request(requestoptions))
            .map((res : Response) => {
                var blob = new Blob([res.blob()], { type: 'xlsx' })
                return blob;
            });

    }

   
    uploadDocument(documents: File): Observable<any> {
        const formData = new FormData();
            formData.append("file", documents);
            formData.append("UserId",localStorage.getItem('mcmt_userId'));
            
        let headers = new Headers({'Authorization':'Bearer '+ localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions: RequestOptions = new RequestOptions({
            headers: headers
        })
        return this.http.post(this.ROOT_URL + "/api/Inventory/UploadDocument", formData, requestoptions)
            .map((res: Response) => {
            return res.json();
            });
        }
   

    
    getJobnumberDropdowns(ddlResponse : DropDownResponse) : Observable<any> {
        let _body = {
            "UserID" : localStorage.getItem('mcmt_userId'),
            "Data" : ddlResponse
          }
          let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization':'Bearer '+ localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions : RequestOptions = new RequestOptions({
            method : 'POST',
            url : this.ROOT_URL + "/api/Account/GetJobnumberDropdowns",
            headers : headers,
            body : _body
        })
        
        return this.http.request(new Request(requestoptions))
            .map((res : Response) => {
                return res.json();
            });

    }
}
